module.exports = __webpack_public_path__ + "img/veg_mushroom.39b9efa4.png";